// extracted by mini-css-extract-plugin
export default {"container":"e0yZi4DEph8P4rJdcgPM","subheader":"VzRVFvbZ9qxGr9p_vMUs"};